export default __webpack_public_path__ + "img/ded71490a01853a2ac33834811efc46f.jpg";